export default "__VITE_ASSET__Cm3f6qhx__"